import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 50em;
  min-height: 100%;
  padding: 1px 3rem 5rem;
  background-color: white;
`;

function Page({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

export default Page;



// WEBPACK FOOTER //
// ./src/app/Page.js